import { render, staticRenderFns } from "./Videojs.vue?vue&type=template&id=cb5db4a8&scoped=true&"
import script from "./Videojs.vue?vue&type=script&lang=js&"
export * from "./Videojs.vue?vue&type=script&lang=js&"
import style0 from "./Videojs.vue?vue&type=style&index=0&id=cb5db4a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5db4a8",
  null
  
)

export default component.exports